import Swiper from 'swiper/dist/js/swiper';
import Swiper2 from 'swiper-lastest/swiper-bundle.min.js';


import { createSearch } from './common/search';
import { language, apiUrl, getParameter, serviceCode, getFormatDate, getLocale } from './common/utils';
import { l10n } from './common/l10n';

(($) => {
  let parameter = getParameter();
  let parameter_title = parameter.title || '';
  let parameter_alias = parameter.alias || '';
  const apiURL = parameter_alias ?  `${apiUrl}/${serviceCode}/guide/alias/${parameter_alias}` : `${apiUrl}/${serviceCode}/guide/${parameter_title}`;

  $(async () => {
    createSearch();

    if ($('#ncGuidebookTemplate').addClass('nc-guidebook-template').length) {
      createView();
    }
  });

  function createView () {
    $('#ncGuidebookTemplate').append(`
      <div class="ncgbt-container"></div>
      <button type="button" class="ncgbt-btn-top">${l10n('common.top', language)}</button>
    `);

    $('.ncgbt-btn-top').on('click', function () {
      $('html, body').animate({ scrollTop: 0 }, 300);
    });

    getGuide();
  }

  function contentChangeLink(content){
    const reContent =  content.replace(/({(?:country|lang)})/g, (string) => getLocale()[string.replace(/[{}]/g, '')]);
    return reContent;
  }

  function getGuide () {
    return new Promise((resolve, reject) => {
      $.ajax({
        method: 'GET',
        dataType: 'json',
        cache: false,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        //http://opdev.lineage2m.plaync.com/api/v2/{gameName}/guide/{가이드명}?gwLocale=ko_KR
        //http://opdev.lineage2m.plaync.com/api/v2/{gameName}/guide/alias/{Alias}?gwLocale=ko_KR
        url: apiURL
      }).done((data) => {

        const { content, paragraphList, updateTime, tags, relationGuideList, extraData, backgroundUrl, dataType } = data;

        if (extraData && JSON.parse(extraData).rootCategoryId) {
          $('.ncgb-btn-list').attr('href', `list#categoryId=${JSON.parse(extraData).rootCategoryId}`);
        } else {
          $('.ncgb-btn-list').attr('href', 'list');
        }

        // 커버
        let result = '';

        if(dataType === 1){ // 클래스 소개 dataType : 1
          const name = paragraphList[0].name;
          const extractSpanPattern = /<(\/p|p)([^>]*)>/gi; //P 태그 제거 정규식
          const classList = JSON.parse(paragraphList[0].content.replace(extractSpanPattern, ''));
          const jobChangeList = classList.jobChange;
          const itemsList = classList.items;
          const skillsList = classList.skills;

          const classArray = Object.keys(classList);
          const jobChangeArray = Object.keys(jobChangeList);
          const itemsArray = Object.keys(itemsList);
          const skillsArray = Object.keys(skillsList);

          // 클래스 소개
          if (classList && classArray.length) {
            result += `
            <div class="ncgbt-class-introducing">
              <div class="ncgbt-class-introducing-infos-wrap" style="background-image: url(${classList.backgroundClassImagePc})">
                  <div class="class-infos" style="background-image: url(${classList.backgroundClassImageMobile})">
                      <div class="class-info info-position-top">
                          <p class="class-info-occupation">${classList.job}</p>
                          <h1 class="class-info-name">${name}</h1>
                      </div>
                      <div class="class-info info-position-middle">
                          <div>
                              <h2 class="class-info-title">종족</h2>
                              <p class="class-info-contents">${classList.tribe}</p>
                          </div>
                          <div>
                              <h2 class="class-info-title">전직계보</h2>
                              <ul class="class-info-contents">
            `;

            jobChangeArray.forEach((key) => {
              const jobChange = jobChangeList[key];
              if(jobChange !== '""'){result += `<li>${jobChange}</li>`;}
            });

            result += '</ul></div></div>';
            result += '<div class="class-info info-position-bottom"><h2 class="class-info-title">전용 무기</h2><ul class="class-info-contents">';

            itemsArray.forEach((key) => {
              const items = itemsList[key];
              if(items.name){
                result += `<li style="background-image: url(${items.image})"><span class="class-info-item">${items.name}</span></li>`;
              }
            });

            result += '</ul></div></div></div>';
            result += `<div class="ncgbt-article"><h1 class="ncgbt-article-title">특징</h1><p>${classList.summary}</p></div>`;
            result += '</div>';
          }

          // 주요 스킬
          if (skillsList && skillsArray.length) {
            result += '<div class="ncgbt-class-skills"><div class="ncgbt-article"><h1 class="ncgbt-article-title">주요스킬</h1></div><div class="ncgbt-class-skills-swiper-wrap"><div class="class-skills-views-wrap"><div class="swiper class-skills-views"><div class="swiper-wrapper">';
              skillsArray.forEach((key) => {
              const skills = skillsList[key];
              result += `
              <div class="swiper-slide class-skills-view-wrap">
                  <div class="class-skills-view-setting-ratio">
                      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/${skills.movieId}?loop=1&playlist=${skills.movieId}" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>
                  </div>
              </div>
              `;
            });
            result += '</div></div>';
            result += '<div class="class-skills-explanation-wrap">';
            skillsArray.forEach((key) => {
              const skills = skillsList[key];
              result += `<div class="class-skills-explanation"><h2 class="class-skills-name">${skills.name}</h2><p class="class-skills-desc">${skills.summary}</p></div>`;
            });
            result += '</div>';
            result += '<div class="swiper class-skills-thumbs"><div class="swiper-wrapper">';
            skillsArray.forEach((key) => {
              const skills = skillsList[key];
              result += `<div class="swiper-slide class-skills-thumbs-img-wrap"><img src="${skills.image}"/></div>`;
            });
            result += '</div></div>';
            result += '<div class="swiper-class-button-next"></div><div class="swiper-class-button-prev"></div>';
            result += '</div></div></div>';
          }
        }else{ // 일반 가이드 dataType : 0
          // 커버
          result = content;
          // 목차
          if (paragraphList && Object.keys(paragraphList).length > 1) {
            result += `<div class="ncgbt-article-list-wrap is-active"><a href="#" class="ncgbt-article-list-btn">${l10n('view.toc', language)}<i class="ncgbt-article-list-btn-arrow"></i></a><a href="#" class="ncgbt-article-list-close">${l10n('view.toc.close', language)}</a><div class="ncgbt-article-list"><ul>`;
            paragraphList && Object.keys(paragraphList).forEach((key, index) => {
              result += `<li><a href="#paragraph-${index + 1}">${paragraphList[key].name}</a></li>`;
            });
            result += '</ul></div></div>';
          }
        }

        // 단락
        paragraphList && Object.keys(paragraphList).forEach(function (key, index) {
          // 클래스 소개 데이터 검색어 연동관련 미노출 처리
          if(dataType === 1){
            if(paragraphList[key] !== paragraphList[0]){
              const contentAddPlaysinline = contentChangeLink(paragraphList[key].content.replace(/wmode=opaque/gi, 'wmode=opaque&amp;playsinline=1'));
              // result += `<div class="ncgbt-article"><h1 id="paragraph-${index + 1}" class="ncgbt-article-title">${paragraphList[key].name}</h1><p>${contentAddPlaysinline}</p></div>`;
              result += `<div class="ncgbt-article"><h1 id="paragraph-${index + 1}" class="ncgbt-article-title">${paragraphList[key].name}</h1><p>${contentAddPlaysinline}</p></div>`;
            }
          }else{
            const contentAddPlaysinline = contentChangeLink(paragraphList[key].content.replace(/wmode=opaque/gi, 'wmode=opaque&amp;playsinline=1'));
            // result += `<div class="ncgbt-article"><h1 id="paragraph-${index + 1}" class="ncgbt-article-title">${paragraphList[key].name}</h1><p>${contentAddPlaysinline}</p></div>`;
            result += `<div class="ncgbt-article"><h1 id="paragraph-${index + 1}" class="ncgbt-article-title">${paragraphList[key].name}</h1><p>${contentAddPlaysinline}</p></div>`;
          }
        });

        // 업데이트 날짜
        if (window.guidebook.updateNoticeURL) {
          result += `<div class="ncgbt-update-new"><p class="info">${l10n('view.update.description', language, `<span class="date">${getFormatDate(updateTime)}</span>`, window.guidebook.updateNoticeURL)}</p></div>`;
        } else {
          result += `<div class="ncgbt-update"><span class="name">${l10n('common.update', language)}</span><span class="date">${getFormatDate(updateTime)}</span></div>`;
        }

        // 태그
        result += '<div class="ncgbt-wrap-tag"><div class="ncgbt-wrap-tag_surface"></div><ul class="ncgbt-tag-list">';

        tags && tags.split(',').forEach((tag) => {
          result += `<li class="ncgbt-tag-items"><a href="search#field=tags&keyword=${tag}" class="text">${tag}</a></li>`;
        });

        result += '</ul></div>';


        // 연관/추천
        const relationGuideArray = Object.keys(relationGuideList);

        if (relationGuideList && relationGuideArray.length) {
          result += `<div class="ncgbt-related-wrap"><h1 class="ncgbt-related-title">${l10n('view.relation-page', language)}</h1><div class="swiper-container ncgbt-related-swiper-container"><div class="swiper-wrapper ncgbt-related-list">`;

          relationGuideArray.forEach((key) => {
            const guide = relationGuideList[key];

            result += '<div class="swiper-slide ncgbt-related-items"><a href="view?title=' + encodeURI(guide.guidebook.name) + '"><div class="title">' + guide.guidebook.name + '</div><span class="category">' + (guide.type === 0 ? `${l10n('view.relation', language)}` : `${l10n('view.recommand', language)}`) + '</span>' + (guide.guidebook.thumbnailUrl ? '<img src="' + guide.guidebook.thumbnailUrl + '">' : '') + '</a></div>';
          });

          result += `</div><div class="ncgbt-related-paging"><span class="current">1</span>/<span class="total">${relationGuideArray.length}</span></div><div class="swiper-pagination"></div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div>`;
          result += '</div></div>';
        }

        $('#ncGuidebookTemplate .ncgbt-container').empty().append(result);

        if(dataType == 0){
          if(backgroundUrl && backgroundUrl != $('.ncgbt-cover-img').css('background-image').replace(/^url\(['"](.+)['"]\)/, '$1')){
            $('.ncgbt-cover-img').css({'background-image':`url(${backgroundUrl})`});
          }
        }
        // 빈 p 태그 제거
        $('.ncgbt-article').find('p:empty').remove();
        //$('.ncgbt-article > p > br:only-child').closest('p').remove();

        // 비디오 태그 래핑
        $('.fr-video').wrapInner('<div class="fr-video-inner"></div>');

        // 테이블 래핑
        $('table').each(() => {
          if (!$(this).parent().hasClass('ncgbt-table-scroller')) $(this).wrap('<div class="ncgbt-table-scroller">');
        });

        // 목차 토글
        $('.ncgbt-article-list-btn').on('click', function (event) {
          event.preventDefault();

          $(this).siblings('.ncgbt-article-list-close').css({ display: 'inline-block' });
          $(this).css({ display: 'none' }).parent().addClass('is-active');
        });

        $('.ncgbt-article-list-close').on('click', function (event) {
          event.preventDefault();

          $(this).siblings('.ncgbt-article-list-btn').css({ display: 'inline-block' });
          $(this).css({ display: 'none' }).parent().removeClass('is-active');
        });

        // 목차 바로가기
        $('.ncgbt-article-list').find('a').each(function () {
          $(this).on('click', function (event) {
            event.preventDefault();

            $('html, body').animate({ scrollTop: $('#' + $(this).attr('href').substr(1)).offset().top - 100 }, 300);
          });
        });

        // 그룹 이미지
        $('.fr-ig-slide').each(function () {
          const $this = $(this);

          if (!$this.find('.swiper-button-next').length) $this.append('<div class="swiper-button-next"></div>');
          if (!$this.find('.swiper-button-prev').length) $this.append('<div class="swiper-button-prev"></div>');
          if (!$this.find('.swiper-pagination').length) $this.append('<div class="swiper-pagination"></div>');
        });

        new Swiper('.fr-ig-slide', {
          slidesPerView: 'auto',
          pagination: {
            el: '.swiper-pagination',
            type: 'progressbar'
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        });

        new Swiper('.ncgbt-related-swiper-container', {
          watchOverflow:true,
          slidesPerView: 4,
          slidesPerGroup: 1,
          spaceBetween: 28,
          pagination: {
            el: '.swiper-pagination',
            type: 'progressbar'
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            959: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 0,
            }
          },
          on: {
            slideChangeTransitionEnd () {
              $('.ncgbt-related-paging .current').text(this.activeIndex + 1);
            },
          }
        });

        //클래스 소개 주요 스킬 swiper
        if(dataType == 1) {
          const classSkillsThumbs = $('.class-skills-thumbs');
          let classThumbs;
          let options = function(loop) {
            return {
              loop: loop? true : false,
              centeredSlides: loop? true : false,
              slidesPerView: 7,
              navigation: {
                nextEl: '.swiper-class-button-next',
                prevEl: '.swiper-class-button-prev',
              },
              breakpoints: {
                320: {
                  slidesPerView: 4.8,
                  spaceBetween: 16
                },
                480: {
                  slidesPerView: 6,
                  spaceBetween: 16
                },
                640: {
                  slidesPerView: 7,
                  spaceBetween: 16
                },
                960: {
                  slidesPerView: 7,
                  spaceBetween: 24,
                }
              }
            };
          };
          classSkillsThumbs.each(function(i, el) {
              if ($(el).find('.class-skills-thumbs-img-wrap').length > 4) {
                  classThumbs = new Swiper2('.class-skills-thumbs', options(true));
              } else {
                  classThumbs = new Swiper2('.class-skills-thumbs', options());
                  $(el).addClass('class-skills-thumbs-center');
              }
          });
          const classView = new Swiper2('.class-skills-views', {
            loop: true,
            slidesPerView: 1,
            thumbs: {
              swiper: classThumbs,
            }
          });
          classView.on('transitionEnd', function() {
            const index_currentSlide = classView.realIndex;
            $('.class-skills-explanation').eq(index_currentSlide).addClass('active').siblings().removeClass('active');
            $('iframe').each(function () {
              $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
            });
          });
          $('.class-skills-explanation').eq(0).addClass('active');
        }

        resolve();
      }).fail(() => {
        reject();
        location.href = `search#field=guide_name,content&keyword=${parameter_title}`;
        // if(parameter_title) {
        //
        // }else{
        //   location.href ='/support/404';
        // }//'/support/404';

      });
    });
  }
})(window.jQuery);



